import { FC } from 'react'
import Svg, { ClipPath, Defs, G, Path, SvgProps } from 'react-native-svg'

const LanIcon: FC<SvgProps> = (props) => {
    return (
        <Svg fill="none" viewBox="0 0 15 14" width="15" height="14" {...props}>
            <G stroke="#231F20" strokeLinecap="round" strokeWidth="1.2" clipPath="url(#a)">
                <Path strokeMiterlimit="10" d="M1.1 6.89h13.1" />
                <Path
                    strokeLinejoin="round"
                    d="M9.84.6H5.47v3.88h4.37V.6ZM5.69 9.34H1.32v3.88h4.37V9.34ZM13.98 9.34H9.61v3.88h4.37V9.34Z"
                />
                <Path strokeMiterlimit="10" d="M7.65 4.48v2.37M3.38 7.19v2.02M11.73 7.19v2.02" />
            </G>
            <Defs>
                <ClipPath id="a">
                    <Path fill="#fff" d="M.5 0h14.3v13.83H.5z" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default LanIcon
